import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Localidad } from './entity-localidades.model';

@Injectable({
  providedIn: 'root'
})
export class LocalidadesService {
  url: string;

  constructor(private http: HttpClient) {}

  getLocalidades(departamento: string): Observable<Localidad[]> {
    return this.http.get<Localidad[]>(
      `${this.url}/localidades/?departamento_codigo=${departamento}`
    );
  }

  getAllLocalidades(): Observable<Localidad[]> {
    return this.http.get<Localidad[]>(`${this.url}/localidades/`);
  }
}
